module.exports = __webpack_public_path__ + "img/refund_1.0a6e478b.png";